import React, { useState, useEffect } from "react";
import AdmsIdentifierView from "./AdmsIdentifierView";
import AdmsIdentifier from "../formModels/AdmsIdentifier";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { Stack, Box, Tooltip, Typography } from "@mui/material";

export default function AdmsIdentifierListView({ title, subtitle, obj, onIdentifierChange, padding, classNameToHave, lang, required, schemaAsObject }) {
  const [mainModels, setMainModels] = useState([]);
  // console.log("OBJ", obj);
  useEffect(() => {
    const initialModels = obj.length ? obj : [new AdmsIdentifier()];
    setMainModels(initialModels);
  }, [obj]);

  // Function to add a new identifier
  const addMainModel = (e) => {
    e.stopPropagation();
    const newModel = new AdmsIdentifier();
    const updatedModels = [...mainModels, newModel];
    setMainModels(updatedModels);
    onIdentifierChange(updatedModels);
  };

  // Function to remove an identifier by index
  const removeMainModel = (e, index) => {
    e.stopPropagation();
    const updatedModels = mainModels.filter((_, i) => i !== index);
    setMainModels(updatedModels);
    onIdentifierChange(updatedModels);
  };

  // Function to handle identifier updates
  const handleIdentifierUpdate = (index, updatedIdentifier) => {
    const updatedModels = [...mainModels];
    updatedModels[index] = updatedIdentifier;
    setMainModels(updatedModels);
    onIdentifierChange(updatedModels);
  };
  // console.log("mainModels", mainModels);
  return (
    <Box className={classNameToHave || ""} sx={{ p: padding || 0 }}>

      <fieldset>
        <legend>
          <Typography variant="h4">{title}</Typography>
        </legend>
        <Stack spacing={2}>
          <Typography variant="h5" gutterBottom>{subtitle}</Typography>

          {mainModels.map((item, index) => (
            <Stack key={index} spacing={4}>
              <AdmsIdentifierView
                obj={item}
                lang={lang}
                schemaAsObject={schemaAsObject}
                onChange={(updatedIdentifier) => handleIdentifierUpdate(index, updatedIdentifier)}
                required={required}
              />
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Tooltip title="Add another identifier"><AddCircleIcon onClick={addMainModel} /></Tooltip>
                {mainModels.length > 1 && (
                  <Tooltip title="Remove this identifier"><RemoveCircleIcon onClick={(e) => removeMainModel(e, index)} /></Tooltip>
                )}
              </div>
            </Stack>
          ))}
        </Stack>
      </fieldset>
    </Box>
  );
}
